<template>
  <el-row>
    <div class="row">
      <w-operation-state-info :params="params" :rsc-info="operationStateParams" :active="active" v-show="isShowOperationState"></w-operation-state-info>
      <el-col :md="12" :lg="12">
        <w-perf-widget :show-change-btn="false">
          <span slot="perfHeader">구성 정보</span>
          <div slot="perfBody">
            <el-col :md="24" :lg="12">
              <table class="list-none-border">
                <tr>
                  <th>장비명</th>
                  <td>{{getEmptyText(configInfoData.objName)}}</td>
                </tr>
                <tr>
                  <th>IP</th>
                  <td>{{getEmptyText(configInfoData['VVM_COMMON/IPADDRESS'])}}</td>
                </tr>
                <tr>
                  <th>가상화 벤더</th>
                  <td>{{getEmptyText(configInfoData.basicinfoSubname)}}</td>
                </tr>
                <tr>
                  <th>장비 종류</th>
                  <td>{{objtypeNameWidthTemplate}}</td>
                </tr>
              </table>
            </el-col>
            <el-col :md="24" :lg="12">
              <table class="list-none-border">
                <tr>
                  <th>VM 별칭</th>
                  <td>{{getEmptyText(configInfoData.vmDesc)}}</td>
                </tr>
                <tr>
                  <th>VM운영체제</th>
                  <td>{{getEmptyText(configInfoData['VVM_COMMON/OS'])}}</td>
                </tr>
                <tr>
                  <th>호스트 IP</th>
                  <td>{{getEmptyText(configInfoData['VVM_COMMON/HOST_IPADDRESS'])}}</td>
                </tr>
                <tr>
                  <th>관리자 (정/부)</th>
                  <td>{{ getEmptyText(configInfoData.objManagerIdMajor) }} / {{ getEmptyText(configInfoData.objManagerIdMinor) }}</td>
                </tr>
              </table>
            </el-col>
          </div>
          <div slot="perfFooter">
            <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }} </span>
          </div>
        </w-perf-widget>
      </el-col>
      <el-col :md="12" :lg="12">
        <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
      </el-col>
      <el-col :md="12" :lg="12">
        <w-perf-widget @change-widget-view="changeWidgetView('CPU', ...arguments)" :show-change-btn="false" :eventlevel="cpuData.eventlevel">
          <span slot="perfHeader">CPU</span>
          <!-- BODY -->
          <ul class="event-info-list" v-if="cpuViewIndex === 0" slot="perfBody">
            <w-perf-body-info v-for="data in cpuData.frontBody" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <w-summary-line-chart v-else slot="perfBody" :series="cpuData.backBody"></w-summary-line-chart>
          <!-- FOOTER -->
          <ul class="legend list" v-if="cpuViewIndex === 0" slot="perfFooter">
            <w-perf-footer-v-info v-for="data in cpuData.frontFooter" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <ul class="legend list" v-else slot="perfFooter">
            <w-perf-footer-v-info v-for="data in cpuData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(cpuData.backBody, data) }" />
          </ul>
        </w-perf-widget>
      </el-col>
      <el-col :md="12" :lg="12">
        <w-perf-widget @change-widget-view="changeWidgetView('MEM', ...arguments)" :show-change-btn="false" :eventlevel="memData.eventlevel">
          <span slot="perfHeader">메모리</span>
          <!-- BODY -->
          <ul class="event-info-list" v-if="memViewIndex === 0" slot="perfBody">
            <w-perf-body-info v-for="data in memData.frontBody" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <w-summary-line-chart v-else slot="perfBody" :series="memData.backBody"></w-summary-line-chart>
          <!-- FOOTER -->
          <ul class="legend list" v-if="memViewIndex === 0" slot="perfFooter">
            <w-perf-footer-v-info v-for="data in memData.frontFooter" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <ul class="legend list" v-else slot="perfFooter">
            <w-perf-footer-v-info v-for="data in memData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(memData.backBody, data) }" />
          </ul>
        </w-perf-widget>
      </el-col>
      <el-col :md="12" :lg="12">
        <w-perf-widget @change-widget-view="changeWidgetView('DISK', ...arguments)" :show-change-btn="false" :eventlevel="diskData.eventlevel">
          <span slot="perfHeader">스토리지</span>
          <!-- BODY -->
          <ul class="event-info-list" v-if="diskViewIndex === 0" slot="perfBody">
            <w-perf-body-info v-for="data in diskData.frontBody" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <w-summary-line-chart v-else slot="perfBody" :series="diskData.backBody"></w-summary-line-chart>
          <!-- FOOTER -->
          <ul class="legend list" v-if="diskViewIndex === 0" slot="perfFooter">
            <w-perf-footer-v-info v-for="data in diskData.frontFooter" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <ul class="legend list" v-else slot="perfFooter">
            <w-perf-footer-v-info v-for="data in diskData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(diskData.backBody, data) }" />
          </ul>
        </w-perf-widget>
      </el-col>
      <el-col :md="12" :lg="12">
        <w-perf-widget @change-widget-view="changeWidgetView('DISKIO', ...arguments)" :show-change-btn="false" :eventlevel="diskioData.eventlevel">
          <span slot="perfHeader">디스크 I/O</span>
          <!-- BODY -->
          <ul class="event-info-list" v-if="diskioViewIndex === 0" slot="perfBody">
            <w-perf-body-info v-for="data in diskioData.frontBody" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <w-summary-line-chart v-else slot="perfBody" :series="diskioData.backBody"></w-summary-line-chart>
          <!-- FOOTER -->
          <ul class="multi" v-if="diskioViewIndex === 0" slot="perfFooter">
            <w-perf-footer-h-info v-for="data in diskioData.frontFooter" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <ul class="legend list" v-else slot="perfFooter">
            <w-perf-footer-v-info v-for="data in diskioData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(diskioData.backBody, data) }" />
          </ul>
        </w-perf-widget>
      </el-col>
      <el-col :md="24" :lg="24">
        <w-perf-widget  @change-widget-view="changeWidgetView('NETIO', ...arguments)" :show-change-btn="false" :eventlevel="netioData.eventlevel">
          <span slot="perfHeader">네트워크 I/O</span>
          <!-- BODY -->
          <ul class="event-info-list" v-if="netioViewIndex === 0" slot="perfBody">
            <w-perf-body-info v-for="data in netioData.frontBody" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <w-summary-line-chart v-else slot="perfBody" :series="netioData.backBody"></w-summary-line-chart>
          <!-- FOOTER -->
          <ul class="multi" v-if="netioViewIndex === 0" slot="perfFooter">
            <w-perf-footer-h-info v-for="data in netioData.frontFooter" :key="data.widgetKey" :widget-info="data" />
          </ul>
          <ul class="legend list" v-else slot="perfFooter">
            <w-perf-footer-v-info v-for="data in netioData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(netioData.backBody, data) }" />
          </ul>
        </w-perf-widget>
      </el-col>
    </div>
  </el-row>
</template>

<script>
import { convertValuByUnit } from '@/utils/number';
import { mapGetters } from 'vuex';
import VmsApi from '@/api/virtual/performance/summary';
import { isEmpty, clone, isNil } from 'lodash';
import { VIRTUAL_HYPERV } from '@/constants/summary';
import { EMPTY_TEXT } from '@/utils/string';
import moment from 'moment';
import summaryApi from '@/api/performance/summary/summary-info';
import perfApi from '@/api/virtual/performance/config';
import { getIntervalDatetimeParams } from '@/utils/date';
import WOperationStateInfo from '../../components/OperationStateInfo';
import WPerfWidget from '../../components/PerfWidget';
import WPerfBodyInfo from '../../components/PerfBodyInfo';
import WPerfFooterVInfo from '../../components/PerfFooterVInfo';
import WPerfFooterHInfo from '../../components/PerfFooterHInfo';
import WEventInfoWidget from '../../components/EventInfoWidget';
import WSummaryLineChart from '../../components/SummaryLineChart';

export default {
  name: 'WHypervVmView',
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterVInfo,
    WPerfFooterHInfo,
    WEventInfoWidget,
    WSummaryLineChart,
    WOperationStateInfo,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  computed: {
    isShowOperationState() {
      if (this.configInfoData.vmTemplateFlag === '0') {
        return true;
      }
      return false;
    },
    objtypeNameWidthTemplate() {
      if (this.configInfoData.vmTemplateFlag === '1') {
        return `${this.configInfoData.objtypeName} (템플릿)`;
      }
      return this.configInfoData.objtypeName;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'VMS',
        managetypeKey: 'VVM',
      },
      operationStateParams: {
        rsctypeId: 'VVM_RUNNINGSTATUS',
        rscId: 'ALIVE',
        rscKey: '_',
      },
      configInfoData: {
        checkDatetimeLabel: '',
      },
      eventInfoData: {},
      cpuViewIndex: 1,
      memViewIndex: 1,
      diskViewIndex: 1,
      diskioViewIndex: 1,
      netioViewIndex: 1,
      cpuData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      memData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      diskData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      diskioData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      netioData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
    };
  },
  methods: {
    getIntervalDatetimeParams,
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();

        const widgetKeyList = ['CPU', 'MEM', 'DISK', 'DISKIO', 'NETIO'];
        widgetKeyList.forEach((widgetKey) => {
          const widgetKeyLower = widgetKey.toLowerCase();
          this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
        });
      }
    },
    loadConfInfoView() {
      perfApi.getNodeConfigInfoForObjtype({
        objId: this.selectedNode.obj.objId,
        objtypeId: 'VVM',
      }).then((response) => {
        if (response.data.success && response.data.data.length > 0) {
          this.configInfoData = response.data.data[0];
          this.configInfoData.checkDatetimeLabel = !isNil(this.configInfoData.checkDatetime) ? moment(this.configInfoData.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
        }
      });
    },
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    // 위젯 전면 또는 후면 데이터 로드
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    // 전면 데이터 로드 함수
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: VIRTUAL_HYPERV.VVM.FRONT[widgetKey],
        rscKey: '_', // 현재 디스크를 제외한 rslt를 조회하는 위젯은 '_'를 Key로 사용함
        objtype: 'vm',
        hypervisorType: this.selectedNode.hypervisorType,
      });
      VmsApi.getSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].frontBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].frontFooter = response.data.data.footer;
        }
      });
    },
    // 후면 데이터 로드 함수
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: VIRTUAL_HYPERV.VVM.BACK[widgetKey],
        rscKey: '_', // 현재 디스크를 제외한 rslt를 조회하는 위젯은 '_'를 Key로 사용함
        objtype: 'vm',
        hypervisorType: this.selectedNode.hypervisorType,
      });
      VmsApi.getSummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].backBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].backFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((e) => {
        if (footer.rsckey) {
          return e.rscInfo.rscKeyName === footer.rscKeyName;
        } else if (e.rscInfo) {
          return e.rscInfo.rsctypeId === footer.rsctypeId && e.rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
    getEmptyText(value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
    convertValuByUnit,
  },
};
</script>

<style scope>
  .list-none-border th {
    width: 142px;
  }
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/virtual/components/HypervVmView.vue